module.exports = __webpack_public_path__ + "img/20.8c4a4aee.jpg";